import { checkPermission } from '@/router/guards.ts'

const AttendantReviewReportModule = () => import('./AttendantReviewReportModule.vue')
const AttendantReviewsReportIndex = () => import('./views/AttendantReviewsReportIndex.vue')

export const attendantReviewReportRoute = {
  path: '/report',
  component: AttendantReviewReportModule,
  meta: {
    requiresAuth: true,
    permission: 'report.view',
    keepAlive: true,
    title: 'Attendant Reviews Report',
  },
  children: [
    {
      path: 'staff-reviews',
      name: 'staff-reviews-report-index',
      component: AttendantReviewsReportIndex,
      beforeEnter: checkPermission('report.reviews_attendant'),
    },
  ],
}
